import Head from 'next/head';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { NextSeo } from 'next-seo';
import { fetchContent } from '@actions/summit';
import { ContextProvider } from '@context/IsMobileContext';
import Summit from '@cont/Summit/Summit';

const SummitPage = ({ isServer, userAgent }) => {
  const metaData = useSelector(({ summit }) => summit.metaData);
  const {
    title: metaTitle,
    description,
    ogImageURL,
    twitterImageURL
  } = metaData;
  return (
    <>
      <NextSeo
        title={metaTitle}
        description={description}
        openGraph={{
          title: metaTitle,
          description,
          images: [
            {
              url: ogImageURL
            }
          ]
        }}
        twitter={{
          images: [
            {
              url: twitterImageURL
            }
          ]
        }}
      />
      <Head>
        <title>{metaTitle}</title>
      </Head>
      <ContextProvider isServer={isServer} userAgent={userAgent}>
        <Summit />
      </ContextProvider>
    </>
  );
};

SummitPage.propTypes = {
  isServer: PropTypes.bool.isRequired,
  userAgent: PropTypes.string.isRequired
};

SummitPage.getInitialProps = async ({ store, isServer, req }) => {
  await store.dispatch(fetchContent('upscsummit2020'));
  return {
    isServer,
    userAgent: isServer ? req.headers['user-agent'] : ''
  };
};

SummitPage.pageInfo = {
  layoutOptions: {
    hideHeader: true,
    hideSearch: true,
    disableDarkMode: true,
    useFreeLayout: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default SummitPage;
